/**
 * Формат отображения аэропорта (ICAO/IATA/both) — согласно SystemSettings.
 */
export type AirportDisplayMode = 'icao' | 'iata' | 'both';

export interface AirportLike {
  icao_code?: string;
  iata_code?: string;
}

export function formatAirport(ap: AirportLike | null | undefined, mode: AirportDisplayMode = 'icao'): string {
  if (!ap) return '—';
  const icao = ap.icao_code || '';
  const iata = ap.iata_code || '';
  switch (mode) {
    case 'iata':
      return iata || icao || '—';
    case 'both':
      if (icao && iata) return `${icao}/${iata}`;
      return icao || iata || '—';
    case 'icao':
    default:
      return icao || iata || '—';
  }
}
